import cn from 'classnames';
import styles from './LikeButton.module.scss';

type LikeButtonProps = {
  className?: string;
  onClick: () => void;
  active?: boolean;
  isSmall?: boolean;
};

export function LikeButton({
  className,
  onClick,
  active,
  isSmall,
}: LikeButtonProps) {
  const wrapperClassName = cn(styles.wrapper, className, {
    [styles.small]: isSmall,
  });

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <img
        src={active ? '/svg/like-filled.svg' : '/svg/like.svg'}
        alt="like"
        className={styles.icon}
      />
    </div>
  );
}
